import { __assign } from "tslib";
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Block } from '../block';
var Heatmap = function (options) {
    var blocks = options.blocks, layout = options.layout;
    return (React.createElement(AnimatePresence, null, blocks.map(function (block) { return (React.createElement(Block, __assign({ key: block.key + "." + layout }, options, { block: block }))); })));
};
export default Heatmap;
